import http from "./httpService";

export function getArchitectures() {
  return http.get("/architectures");
}